<style scoped>
    @import url("../../styles/mainV2/menuSupMainV2.scss");
</style>

<template>
    
    <div class="box_menuSupMain" :style="{'background':'#092d4f'}">
    <!-- <div class="box_menuSupMain" :style="{'background':'#7e8c99'}"> -->
    <!--<div class="box_menuSupMain" 
    :style="{
            backgroundImage:'url(' + require('../../assets/fundo_t.png') + ')',
            backgroundSize: 'cover', // contain
            backgroundPosition: 'center' // top center
            }">-->

        <div class="barra_util">

            <!-- SMALL -->
            <!-- MENU SMALL hidden-md-and-up ,'transform':'rotate(90deg)' -->
            <div @click="openMenuSupMain()" class="btnUser hidden-md-and-up mr-1">
                <div class="btnMenuLarge">
                    <v-icon 
                    large 
                    :style="{'color':'rgba(247,215,46,1)'}"
                    >
                        {{ iconMenu }}
                    </v-icon>
                </div>
            </div>

            <!-- LARGE -->
            <div class="box_logo hidden-sm-and-down" @mouseover="desableAllBtn()">
                <div class="logo_menuSupMain" @click="callMainPage()">
                    <!-- LOGO MENU SUP MAIN -->
                    <div class="el_img">
                        <!--<v-img :src="require('../../assets/0t.png')"/>-->
                        <v-img height="100%" width="100%" cover :src="imageLogo" /><!-- cover -->
                    </div>
                </div>
            </div>

            <!-- SMALL -->
            <div class="box_logo hidden-md-and-up" @mouseover="desableAllBtn()"
            :style="{'width':'50%'}">
                <div class="logo_menuSupMain" @click="callMainPage()">
                    <!-- LOGO MENU SUP MAIN -->
                    <div class="el_img">
                        <!--<v-img :src="require('../../assets/0t.png')"/>-->
                        <v-img cover :src="imageLogo" />
                    </div>
                </div>
            </div>

            <!-- MENU LARGE-->
            <div class="menuLarge hidden-sm-and-down">

                <div 
                v-for="(el,i) in liMenuDrop" :key="i" 
                @click="callPage(el.rota)"
                class="btnMenuLarge"
                @mouseover="changeColorItemMenu(i,'on')"
                @mouseleave="changeColorItemMenu(i,'off')"
                :style="{'background':el.background}"
                >
                    <span class="" :style="{'color':el.cor}">{{ el.name }}</span>
                </div>

                <!--<div class="btnMenuLarge">Quem somos</div>
                <div class="btnMenuLarge">IoT e automação</div>
                <div class="btnMenuLarge">Área do usuário</div>-->
            </div>

            <div @mouseover="desableAllBtn()"
            class="btnUser hidden-sm-and-down">
                <div class="btnMenuLarge" 
                v-for="(ul,k) in liUser" :key="k" 
                @click="callPage(ul.rota)"
                @mouseover="changeColorUser(k,'on')"
                @mouseleave="changeColorUser(k,'off')"
                :style="{'background':ul.background}"
                >
                    <!-- <span class="" :style="{'color':liUser[0].cor}">{{ liUser[0].name }}</span> -->
                    <v-icon class="" :style="{'color':ul.cor}">{{ ul.icon }}</v-icon>
                </div>
            </div>

            <!-- SMALL -->
            <div 
            v-for="(ulx,x) in liUser" :key="x" 
            @click="callPage(ulx.rota)" 
            class="btnUser hidden-md-and-up mr-1">
                <div class="btnMenuLarge">
                    <v-icon 
                    large 
                    :style="{'color':'rgba(247,215,46,1)'}"
                    >
                        {{ ulx.icon }}
                    </v-icon>
                </div>
            </div>

        </div>
            
    </div>

</template>

<script setup>
//import imageLogo from '../../assets/0t.png'
//import imageLogo from '../../assets/upinc_logo_vetor_azul.png'

import imageLogo from '../../assets/logos/upinc_logo_vetor_branco.png'
</script>

<script>
export default {

    props:['iconMenu'],

    data() {
        return {
            flagIconMenuOpened:true,
            //iconMenu:'mdi-menu-close', // 'mdi-menu-open'
            //iconMenu:'mdi-menu', // via props from body -> app -> menu sup

            liMenuDrop:[
                {'rota':'/lorapub','name':'Aplicações públicas','cor':'#7e8c99','background':'','liAbaixo':[{'t':'Rede LoRaWAN Fundão','cor':'','b':'','r':'/lorapub'}]},
                {'rota':'/sobre','name':'Sobre nós','cor':'#7e8c99','background':'','liAbaixo':[]},
                {'rota':'/fale','name':'Contactos','cor':'#7e8c99','background':'','liAbaixo':[]},
                //{'rota':'/automation','name':'Produtos','cor':'','background':'','liAbaixo':[{'t':'Gateways','cor':'','b':'','r':'/'},{'t':'Sensores de Solo','cor':'','b':'','r':'/'},{'t':'Estações Meteorológicas','cor':'','b':'','r':'/'},{'t':'Acionamentos remotos','cor':'','b':'','r':'/'},{'t':'Contadores','cor':'','b':'','r':'/'}]},
                //{'rota':'/automation','name':'Serviços','cor':'','background':'','liAbaixo':[{'t':'LoRaWAN','cor':'','b':'','r':'/'},{'t':'Automação','cor':'','b':'','r':'/'},{'t':'Sensoriamento','cor':'','b':'','r':'/'},{'t':'Plataforma de integração','cor':'','b':'','r':'/'},{'t':'Monitoramento','cor':'','b':'','r':'/'},{'t':'Formação','cor':'','b':'','r':'/'}]},
                //{'rota':'/automation','name':'Aplicações públicas','cor':'','background':'','liAbaixo':[{'t':'Montanha Viva','cor':'','b':'','r':'/'},{'t':'Smart Garden Fundão','cor':'','b':'','r':'/'},{'t':'Smart Garden UPinC','cor':'','b':'','r':'/'}]},
                //{'rota':'/automation','name':'Sobre','cor':'','background':'','liAbaixo':[{'t':'UPinC','cor':'','b':'','r':'/'},{'t':'Internet of Things','cor':'','b':'','r':'/'},{'t':'Parceiros','cor':'','b':'','r':'/'}]},
            ],
            liUser:[
                {'rota':'/','name':'E-Commerce','cor':'#7e8c99','background':'','icon':'mdi-cart-arrow-right'},
                {'rota':'/dashmain','name':'Área do usuário','cor':'#7e8c99','background':'','icon':'mdi-account'}
            ],
        }
    },

    methods: {
        //
        changeColorUser(i,strFlag) {
            //
            if (strFlag == 'on') {

                //this.liUser[i].cor = 'rgb(31,122,177)'
                this.liUser[i].cor = '#f39c12' // -- laranja energético.
                this.liUser[i].background = 'rgba(31,122,177,0.3)'

            } else {

                //this.liUser[i].cor = ''
                this.liUser[i].cor = '#7e8c99' // -- btn desativado com cinza neutro
                this.liUser[i].background = ''
            }
        },
        desableAllBtn(){
            this.$store.state.flagMenuAbaixo = false

            // limpar tudo antes de destacar um botão.
            let c=0
            while (c<this.liMenuDrop.length) {
                //this.liMenuDrop[c].cor = ''
                this.liMenuDrop[c].cor = '#7e8c99' // -- btn desativado com cinza neutro
                this.liMenuDrop[c].background = ''
                c++
            }
        },
        changeColorItemMenu(i,strFlag) {
            //
            if (strFlag == 'on') {

                // limpar tudo antes de destacar um botão.
                let c=0
                while (c<this.liMenuDrop.length) {
                    //this.liMenuDrop[c].cor = ''
                    this.liMenuDrop[c].cor = '#7e8c99' // -- btn desativado com cinza neutro
                    this.liMenuDrop[c].background = ''
                    c++
                }

                this.$store.state.liAbaixo = this.liMenuDrop[i].liAbaixo
                //console.log('[menu sup main] rota: ',this.$store.state.liAbaixo)

                //this.liMenuDrop[i].cor = 'rgb(31,122,177)'
                this.liMenuDrop[i].cor = '#f39c12' // -- laranja energético.
                this.liMenuDrop[i].background = 'rgba(31,122,177,0.3)'

                //console.log('this.liMenuDrop[i].liAbaixo.length: ',this.liMenuDrop[i].liAbaixo.length)
                if (this.liMenuDrop[i].liAbaixo.length > 0) {

                    this.$store.state.flagMenuAbaixo = true // -- able menu abaixo.
                } else { this.$store.state.flagMenuAbaixo = false }

                setTimeout(() => {
                    this.liMenuDrop[i].cor = '#7e8c99' // -- btn desativado com cinza neutro
                    this.liMenuDrop[i].background = ''
                    this.$store.state.flagMenuAbaixo = false
                    //console.log('light menu off')
                },10000); // 10s

            } else {

                if (this.$store.state.flagMenuAbaixo == false) {
                    //this.liMenuDrop[i].cor = '' // -- apenas desable se tiver saído do menu abaixo
                    this.liMenuDrop[i].cor = '#7e8c99' // -- btn desativado com cinza neutro
                    this.liMenuDrop[i].background = ''
                }

                //this.liMenuDrop[i].cor = ''
                //this.liMenuDrop[i].background = ''

                if (this.liMenuDrop[i].liAbaixo.length == 0) {

                    this.$store.state.flagMenuAbaixo = false // -- desable menu abaixo.
                }
            }
            //console.log('$store.state.flagMenuAbaixo: ',this.$store.state.flagMenuAbaixo)
        },
        openMenuSupMain() {
            this.flagIconMenuOpened = !this.flagIconMenuOpened

            if (this.flagIconMenuOpened == true) { // fechar menu drop.
                
                //this.iconMenu = 'mdi-menu' 
                this.$emit('callByMenu','close') // return emit String.

            } else { // abrir menu drop.
                
                //this.iconMenu = 'mdi-menu-up-outline'
                this.$emit('callByMenu','open') // return emit String.
            }
        },
        callMainPage() { 
            //console.log('this.$route.path: ',this.$route.path)
            if(this.$route.path != '/') {
                this.$router.push('/')
            }
         },
         callPage(rota) {
            if(rota != '/') {
                
                this.$router.push(rota)

                //this.$emit('callByMenuBody','close') // return emit String. (trocar icon menu)
                //this.$store.state.flagMenuSup = false
            }
        },
    },

    created() {
        //this.$store.commit('srcIP') // without param. Initial main GET Req.
    }
}

</script>